import React, { useState, useEffect } from 'react';
import {connect, useDispatch} from 'react-redux';
import { bindActionCreators}  from 'redux';
import Loader from 'Loader.js';
import S from 'StyledEventListTreeLayout.js';
import { loadEventMultiCategories, loadCategories } from 'marketActions.js';
import { CategoryTreeHeaderTab, CategoryTreeSportTab, CategoryTreePrematchEventTab } from 'EventListTreeLayout';


const EventListTreePrematch = (props) => {
    
    let {eventSportId, eventSportName, categoryId, categoryName, parentCategoryId, parentCategoryName, eventMultiCategories, categories, isPendingEventMultiCategories,selectedMarketId,storageName} = props;

    const [categoryLevel, setCategoryLevel] = useState(3);
    const [openEventSportId, setOpenEventSportId] = useState(eventSportId);
    const [openEventSportName, setOpenEventSportName] = useState(eventSportName);
    const [openEventCategoryId, setOpenEventCategoryId] = useState([categoryId]);
    const [openEventCategoryName, setOpenEventCategoryName] = useState(categoryName);
    const [openParentCategoryName, setOpenParentCategoryName] = useState(parentCategoryName);
    const [openParentCategoryId, setOpenParentCategoryId] = useState(parentCategoryId);
    const dispatch = useDispatch();
    useEffect(()=>{
        localStorage.setItem(storageName,selectedMarketId)
    },[storageName,selectedMarketId])
    useEffect(() => {
        dispatch(loadEventMultiCategories(openEventCategoryId));
    }, []);

    useEffect(() => {
        dispatch(loadCategories());
    }, []);

    const getSportTabs = () => {

        const selectSport = (sportId, sportName) => {
            setOpenEventSportId(sportId);
            setOpenEventSportName(sportName);
            setCategoryLevel(1);
        };

        let sportTabsJSX = [];
        if (categories.length > 0){
            let sports = categories.filter(o => o.level == 1);
            sports = _.chain(sports).sortBy('sortOrder').value();
            for (let category of sports){
                let { categoryName, categoryId, eventsCount } = category;
                sportTabsJSX.push(
                    <CategoryTreeSportTab key={categoryId} 
                            categoryId={categoryId} 
                            categoryName={categoryName} 
                            categoryCount={eventsCount}
                            selectSport={selectSport}
                            showIcon={true}>
                    </CategoryTreeSportTab>
                );
            }
        }

        return sportTabsJSX;
    };

    const getCountryTabs = () => {

        const selectCountry = (parentId, parentName) => {
            setOpenParentCategoryId(parentId);
            setOpenParentCategoryName(parentName);
            setCategoryLevel(2);
        }; 

        let parentTabsJSX = [];
        if (categories.length > 0){
            let categoriesForSport = categories.filter(o => o.sportId == openEventSportId && o.level == 2);
            categoriesForSport = _.chain(categoriesForSport).sortBy('sortOrder').value();
            for (let category of categoriesForSport){
                let { categoryName, categoryId, eventsCount } = category;
                parentTabsJSX.push(
                    <CategoryTreeSportTab key={categoryId} 
                            categoryId={categoryId} 
                            categoryName={categoryName} 
                            categoryCount={eventsCount}
                            selectSport={selectCountry}
                            showIcon={true}>
                    </CategoryTreeSportTab>
                );

            }
        }

        return parentTabsJSX;
    };

    const getCategoryTabs = () => {

        const selectCategory = (categoryId, categoryName) => {
            setOpenEventCategoryId(categoryId);
            setOpenEventCategoryName(categoryName);
            dispatch(loadEventMultiCategories(categoryId));
            setCategoryLevel(3);
        };

        let categoryTabsJSX = [];
        if (categories.length > 0) {
            let categoriesForParent = categories.filter(o => o.parentCategory == openParentCategoryId);
            categoriesForParent = _.chain(categoriesForParent).sortBy('sortOrder').value();
            
            for (let  category of categoriesForParent){
                let { categoryName, categoryId, eventsCount } = category;
                categoryTabsJSX.push(
                        <CategoryTreeSportTab key={categoryId} 
                            categoryId={categoryId} 
                            categoryName={categoryName} 
                            categoryCount={eventsCount}
                            selectSport={selectCategory}
                            showIcon={false}>
                        </CategoryTreeSportTab>
                )
            }
        }

        return categoryTabsJSX;
    };

    const getEventsList = (events) => {
        let eventsTabsJSX = [];
        for (let event of events) {
            eventsTabsJSX.push(
                <CategoryTreePrematchEventTab key={event.eventId}
                    event={event}>
                </CategoryTreePrematchEventTab>
            );
        }
        
        return eventsTabsJSX;
    };

    const closeModalAcion = () => {
        app.modal.EventList.hideEventListModal();
    };

    return (
        <S.LiveEventListTreeContainer>

            <CategoryTreeHeaderTab setCategoryLevel={setCategoryLevel}
                categoryLevel={categoryLevel} 
                categoryLevelForBackBtn={ categoryLevel-1 }
                isPrematch={true}
                sportName={openEventSportName}
                sportId={openEventSportId} 
                parentCategoryId={openParentCategoryId}
                parentCategoryName={openParentCategoryName}
                categoryName={openEventCategoryName}
                closeModalAcion={closeModalAcion}>    
            </CategoryTreeHeaderTab>

            <S.RowTabContainer>
                { categoryLevel == 0 && getSportTabs() }
                { categoryLevel == 1 && getCountryTabs() }
                { categoryLevel == 2 && getCategoryTabs() }
                { categoryLevel == 3 && (
                     isPendingEventMultiCategories ? <Loader/> : getEventsList(eventMultiCategories)) }
            </S.RowTabContainer>
     
        </S.LiveEventListTreeContainer>
    );
};

const mapDispatchToProps = (dispatch) => {
    const actionsToBind = { loadEventMultiCategories, loadCategories };
    return {
        ...bindActionCreators(actionsToBind, dispatch)
    }
};

const mapStateToProps = ({ MarketData: { eventMultiCategories, categories, isPendingEventMultiCategories } }) => {
    return {
        eventMultiCategories,
        categories,
        isPendingEventMultiCategories
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(EventListTreePrematch);